import { createContext } from 'react';

const AuthenticatedUserContext = createContext(null);

export default AuthenticatedUserContext;
